var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"image-background",style:({..._vm.backgroundImage})}),_c('div',{staticClass:"list-3",class:_vm.container,style:({..._vm.backgroundColor, ..._vm.shadow, ..._vm.padding})},[_c('ul',{staticClass:"list-unstyled",style:({..._vm.color})},[_vm._t("list")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }